module.exports = __webpack_public_path__ + "img/home-header-bg.3292129d.png";